import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppLoadService } from '@ebb-v2/ebb-integration';

import {
  AuthenticationService,
  ApplicationApiService
} from '../../data-services/index';

import {
  IApplication, IApplicationInput, IUser,
  IOptionSets, IOptions, IApprovalTask
} from '@ebb-v2/ebb-integration';

@Component({
    selector: 'ebb-portal-receipt-preretrofit-form',
    templateUrl: './receipt-preretrofit-form.component.html',
    standalone: false
})
export class ReceiptPreretrofitFormComponent implements OnInit {
  @Input() application: IApplication;
  @Input() listOptionSets: IOptionSets[];
  @Input() task: IApprovalTask;

  @Output() emitReceiptPreretrofitFormChangeEvent = new EventEmitter<IApplicationInput>();

  public currentUser: IUser;
  public formReceipts: FormGroup;
  public autoSaveIndicator = false;
  public disableSaveButton = true;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly appLoadService: AppLoadService,
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.initializeForms();
    this.loadReceiptsInfoForm();
  }

  private initializeForms(): void {
    this.formReceipts = this.fb.group({
      permitCost: [null,
        [
          Validators.required,
          Validators.min(1)
          
        ]
      ],
      engineeredPlanCost: [null,
        [
          Validators.required,
          Validators.min(1)
          
        ]
      ],
      totalAmount: [{ value: '', disabled: true }],
    });

    this.formReceipts.valueChanges.subscribe(() => {
      this.totalAmount();
      this.updateSaveButtonState();
    });
  }

  private loadReceiptsInfoForm(): void {
    this.setFormValue('permitCost', this.application.permitCost);
    this.setFormValue('engineeredPlanCost', this.application.engineeredPlanCost);

    if (this.checkReceiptFormLock()) {
      this.disableForm();
    }
  }

  private setFormValue(controlName: string, value: number): void {
    const control = this.formReceipts.get(controlName);
    if (value && value >= 0) {
      control.setValue(value);
    } else {
      control.setValue(0);
    }
  }

  private disableForm(): void {
    this.formReceipts.get('permitCost').disable();
    this.formReceipts.get('engineeredPlanCost').disable();
  }

  public checkReceiptFormLock(): boolean {
  

    let retVal = false;
    if (
      (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true &&
        (this.task.statusCode &&
          this.task.statusCode !== 700000002 && this.application.submissionRejection !== 700000001)) ||
      this.application.eventMitigationReviewSubmitted ||
      this.application.eventFinancialReviewSubmitted ||
      (this.isContractor() &&
        this.application.contractorPermissionsCode === 700000003) ||
      this.application.stageCode === 700000001
    ) {
      retVal = true;
    }
    return retVal;
  }

  public setCostToZeroIfEmpty(event): void {
    const value = event.target.value;
    if (!value || value <= 0) {
      event.target.value = 0;
    }
    this.totalAmount();
  }
  
  public totalAmount(): string {
    const permitCost = this.getFormControlValue('permitCost');
    const engineeredPlanCost = this.getFormControlValue('engineeredPlanCost');
    const totalCost = permitCost + engineeredPlanCost;
    const formattedTotal = totalCost.toFixed(2);
  
    // Prevent triggering a value change event when setting the value
    this.formReceipts.get('totalAmount').setValue(formattedTotal, { emitEvent: false });
    return formattedTotal;
  }
  

  private getFormControlValue(controlName: string): number {
    const control = this.formReceipts.get(controlName);
    return control && !isNaN(control.value) ? Number(control.value) : 0;
  }

  private updateSaveButtonState(): void {
    const isFormPristineOrInvalid = this.formReceipts.pristine || this.formReceipts.invalid;
    const hasValidCosts = this.formReceipts.get('permitCost').value > 0 && this.formReceipts.get('engineeredPlanCost').value > 0;
  
    this.disableSaveButton = isFormPristineOrInvalid || !hasValidCosts;
  }
  

  public onClickSaveReceiptsInfo(): void {
 
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    
    if (this.formReceipts.get('permitCost').value > 0) {
      applicationInput.permitCost = this.formReceipts.get('permitCost').value;
    }else{
      applicationInput.permitCost = 0;
    }
    if (this.formReceipts.get('engineeredPlanCost').value > 0){
          applicationInput.engineeredPlanCost = this.formReceipts.get('engineeredPlanCost').value;
    } else{
      applicationInput.engineeredPlanCost = 0;
    }

    this.autoSaveIndicator = true;

    this.apiApplication.updateApplication(applicationInput, this.application.id)
      .subscribe(() => {
        this.emitReceiptPreretrofitFormChangeEvent.emit(applicationInput);
        this.formReceipts.markAsPristine();
        this.disableSaveButton = true;
        this.autoSaveIndicator = false;
      }, error => console.warn(`ERROR: onClickSaveReceiptsInfo() - ${error}`));
  }

  /***     User Convenience Methods */
  public isHomeowner(): boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
